$(document).ready(function (e) {
    var $container = $('.trial-page'),
    subscriptionType = $('.trial-main', $container).attr('data-subscription-type'),
    mainSellingPlansIds = $('#main-selling-plans-ids').length ? JSON.parse(document.getElementById('main-selling-plans-ids').innerHTML) : false,
    currentStep = 1,
    $window = $(window),
    $customHeader = $('.trial-page-header'),
    $extrasBlock = $('.review-order .extras'),
    $yourSubscriptionBlock = $('.review-order .your-subscription'),
    $todaysOrderBlock = $('.review-order .todays-order'),
    currentUrl = new URL(location),
    urlStep = currentUrl.searchParams.get("step");

    if ($customHeader.length) {
        addShadowToHeader();
        $window.on('scroll', function(){
            addShadowToHeader();
        });
    }

    if ($('.nappies-type-selector input:checked', $container).length) {
        updateNappiesSelect($('.nappies-type-selector input:checked', $container));
    }

    $('.nappies-type-selector input', $container).on('change', function () {
        updateNappiesSelect($(this));
    });

    updateTotals();

    if (urlStep && $('.nappies-type-selector input:checked', $container).length){
        goToStep(+urlStep, replaceHistoryState);
    }
    else {
        goToStep(1, replaceHistoryState);
    }

    $('.main-product-options .single-option-selector__radio', $container).on('change', function(){
        $('.hide-details', $container).removeClass('hide-details');
        $('.get-trial', $container).removeAttr('disabled');
        $('.trial-step-nav', $container).addClass('trial-step-nav-available');
        updateTotals();
        replaceHistoryState();
    });

    $('.optional-product .optional-product-checkbox', $container).on('change', function(){
        updateTotals();
    });

    $('input[name="frequency"]', $container).on('change', function(){
        updateTotals();
    });

    $('.trial-step-nav', $container).on('click', function (){
        goToStep($(this).attr('data-step'), pushHistoryState);
    });

    $('.get-trial', $container).on('click', function (){
        goToStep(2, pushHistoryState);
    });

    $('.review-order-btn', $container).on('click', function (){
        goToStep(3, pushHistoryState);
    });

    $('.complete-trial-order-btn', $container).on('click', function (){
        $(this).addClass('btn--loading');
        removeSubscription(addSubscription);
    });

    if ($extrasBlock.length){
        changeExtrasBlockPosition();
        $window.on('resize', function(){
            changeExtrasBlockPosition();
        });
    }

    window.addEventListener("popstate", function(e){
        e.preventDefault();
        var newUrl = new URL(location),
        step = newUrl.searchParams.get("step");
        if (step){
            goToStep(+step);
        }
        else {
            goToStep(1);
        }
    });

    window.addEventListener('pageshow', function(e) {
        if (e.persisted) {
            if ($('.btn--loading', $container).length){
                $('.btn--loading', $container).removeClass('btn--loading');
            }
        }
    });

    function addShadowToHeader(){
        if ($(window).scrollTop() > 0 && !$customHeader.hasClass('with-shadow')) {
            $customHeader.addClass('with-shadow');
        }
        else if ($(window).scrollTop() == 0){
            $customHeader.removeClass('with-shadow');
        }
    }

    function updateNappiesSelect($input){
        var productType = $input.val();
        var $allOptions = $('.main-product-options .single-option-selector__radio', $container);
        var $currentTypeOptions = $allOptions.filter('[data-product-type="'+productType+'"]');
        $allOptions.closest('.custom-select-option').hide();
        $currentTypeOptions.closest('.custom-select-option').show();
        $('.variant-not-selected', $container).removeClass('variant-not-selected');
        if (!$('.option-main-line-default', $container).length){
            if ($currentTypeOptions.filter(':checked').not(':disabled').length) {
                $currentTypeOptions.filter(':checked').not(':disabled').prop('checked', true).trigger('change');
            }
            else {
                $currentTypeOptions.not(':disabled').first().prop('checked', true).trigger('change');
            }
            $('.get-trial', $container).removeAttr('disabled');
            $('.get-trial', $container).text(theme.trialStrings.trial_step_1_btn);
            $('.trial-step-nav', $container).addClass('trial-step-nav-available');
        }
    }

    function updateTotals(){
        var $trialSelectedVariant = $('.main-product-options .product-single__variants option:selected', $container);
        if (!$trialSelectedVariant.length){
            return;
        }
        var frequencyVal = $('[name="frequency"]:checked', $container).attr('data-option-name');
        var deliveryPrice = +$('.trial-delivery-price', $container).attr('data-price');
        var trialPrice = +$trialSelectedVariant.attr('data-subscribe-price');
        var trialPriceCompare = +$trialSelectedVariant.attr('data-price');
        var trialProductTitle = $trialSelectedVariant.attr('data-product-title');
        var trialVariantTitle = $trialSelectedVariant.attr('data-variant-title');
        var trialVariantDetails = $trialSelectedVariant.attr('data-per-pack-qnt') + ' ' + $trialSelectedVariant.attr('data-product-type');

        var parentVariantId = $trialSelectedVariant.attr('data-parent-variant-id');
        var $parentVariant = $('.parent-product-variants option[value="'+parentVariantId+'"]', $container);
        var subscriptionPrice = $parentVariant.attr('data-subscribe-price') * $parentVariant.attr('data-subscribe-qnt');
        var shippingPrice = $parentVariant.attr('data-include-shipping') ?  +$parentVariant.attr('data-include-shipping') : 0;
        var originalPrice = $parentVariant.attr('data-price') * $parentVariant.attr('data-subscribe-qnt') + shippingPrice;
        var subscriptionProductTitle = $parentVariant.attr('data-product-title') + ' x ' + $parentVariant.attr('data-subscribe-qnt');
        var subscriptionVariantTitle = $parentVariant.attr('data-variant-title');
        var subscriptionVariantDetails = $parentVariant.attr('data-per-subscription');
        var todaysTotal = trialPrice + deliveryPrice;

        $('.total-bar .product-single__price--compare-at', $container).text(theme.Currency.formatMoney(trialPriceCompare, theme.strings.moneyFormat));
        $('.total-bar .product-single__price', $container).text(theme.Currency.formatMoney(trialPrice, theme.strings.moneyFormat));

        $('.todays-order .product-title', $container).text(trialProductTitle);
        $('.todays-order .variant-title', $container).text(trialVariantTitle);
        $('.todays-order .product-details', $container).text(trialVariantDetails);
        $('.todays-order .product-single__price--compare-at', $container).text(theme.Currency.formatMoney(trialPriceCompare, theme.strings.moneyFormat));
        $('.todays-order .product-single__price', $container).text(theme.Currency.formatMoney(trialPrice, theme.strings.moneyFormat));
        $('.todays-total-price', $container).text(theme.Currency.formatMoney(todaysTotal, theme.strings.moneyFormat));
        $('.todays-order .product-image img', $container).attr('src', $trialSelectedVariant.attr('data-variant-img'));

        $('.subscription-product-title', $container).text(subscriptionProductTitle);
        $('.subscription-variant-title', $container).text(subscriptionVariantTitle);
        $('.subscription-product-details', $container).text(subscriptionVariantDetails);
        $('.subscription-product-price', $container).text(theme.Currency.formatMoney(subscriptionPrice, theme.strings.moneyFormat));
        $('.subscription-product-original-price', $container).text(theme.Currency.formatMoney(originalPrice, theme.strings.moneyFormat));
        $('.review-order .subscription-product-image', $container).attr('src', $parentVariant.attr('data-variant-img'));
        if ($parentVariant.attr('data-variant-lifestyle-img')){
            $('.main-subscription-product .subscription-product-image', $container).attr('src', $parentVariant.attr('data-variant-lifestyle-img'));
        }
        else {
            $('.main-subscription-product .subscription-product-image', $container).attr('src', $parentVariant.attr('data-variant-img'));
        }
        if (originalPrice > subscriptionPrice){
            $('.subscription-product-original-price', $container).show();
        }
        else {
            $('.subscription-product-original-price', $container).hide();
        }

        $('.review-order .frequency-value', $container).text(frequencyVal);
        $('.subscription-total-price', $container).text(theme.Currency.formatMoney(subscriptionPrice, theme.strings.moneyFormat));

        var optionalProductsPrice = 0;
        var optionalProductsPriceCompare = 0;
        $('.optional-product .optional-product-checkbox:checked', $container).each(function(){
            var thisPrice = $(this).attr('data-custom-price') ? +$(this).attr('data-custom-price') : +$(this).attr('data-price');
            var thisPriceCompare = +$(this).attr('data-price');
            optionalProductsPrice += thisPrice;
            optionalProductsPriceCompare += thisPriceCompare;
        });
        $('.main-total-price .product-single__price--compare-at', $container).text(theme.Currency.formatMoney(optionalProductsPriceCompare + trialPriceCompare, theme.strings.moneyFormat));
        $('.main-total-price .product-single__price', $container).text(theme.Currency.formatMoney(optionalProductsPrice + trialPrice, theme.strings.moneyFormat));
    }

    function addSubscription(){
        var productsToBeAdded = [];
        var frequencyVal = $('[name="frequency"]:checked', $container).val();
        var $trialSelectedVariant = $('.main-product-options .product-single__variants option:selected', $container);
        var variantId = $trialSelectedVariant.attr('value');
        var subscriptionPlanIds = JSON.parse($trialSelectedVariant.attr('data-subscription-plans'));
        var subscriptionPlanOptions = JSON.parse($trialSelectedVariant.attr('data-subscription-plans-options'));
        var frequencyIndexInOptions = subscriptionPlanOptions.indexOf(frequencyVal);
        var productData = {
            id: variantId,
            quantity: 1,
            selling_plan: subscriptionPlanIds[frequencyIndexInOptions],
            properties: {
                '_gwa_subscription': '1',
                '_gwa_subscription_trial': '1'
            }
        };
        if (subscriptionType){
            productData.properties['_gwa_subscription_type'] = subscriptionType;
        }
        productsToBeAdded.push(productData);

        $('.optional-product .optional-product-checkbox:checked', $container).each(function(){
            var customPrice = $(this).attr('data-custom-price') ? true : false;
            var variantId = $(this).val();
            var productObj = {
                id: variantId,
                quantity: 1
            }
            if (customPrice) {
                productObj.properties = {
                    "_custom_trial_price": "true"
                }
            }
            productsToBeAdded.push(productObj);
        });

        $.ajax({
            type:     'POST',
            url:      '/cart/add.js',
            data: {"items": productsToBeAdded},
            dataType: 'json',
            success:  function () {
                if (subscriptionType){
                    $.ajax({
                        type: 'POST',
                        url: '/cart/update.js',
                        dataType: 'json',
                        data: {
                            attributes: {
                                'primary_product_type': subscriptionType
                            }
                        },
                        success: function (response) {
                            window.location.href = '/checkout?skip_shop_pay=true';
                        },
                        error: function(XMLHttpRequest, textStatus){
                            console.log('error');
                            console.log(XMLHttpRequest, textStatus);
                        }
                    });
                }
                else {
                    window.location.href = '/checkout?skip_shop_pay=true';
                }

            },
            error:    function (XMLHttpRequest, textStatus) {
                console.log(XMLHttpRequest, textStatus);
                $('.complete-trial-order-btn', $container).removeClass('btn--loading');
                var data = eval('(' + XMLHttpRequest.responseText + ')');
                if (data.message) {
                    if (data.status === 422) {
                        $("html, body").animate({ scrollTop: 0 }, 1000);
                        $('.top-message-text').text(data.description);
                        $('.top-message').slideDown(300);
                    }
                    else {
                        $("html, body").animate({ scrollTop: 0 }, 1000);
                        $('.top-message-text').text('Something went wrong. Please try again!');
                        $('.top-message').slideDown(300);
                    }
                }
            }
        });
    }

    function removeSubscription(callback) {
        var cartQntArray = [];
        $.ajax({
            type:     'GET',
            url:      '/cart.js',
            dataType: 'json',
            success:  function (cart) {
                var subscriptionInCart = false;
                var anotherSubscriptionInCart = false;
                var mainProductInCart = false;
                for (i = 0; i < cart.items.length; i++) {
                    if (cart.items[i].selling_plan_allocation) {
                        cartQntArray.push(0);
                        subscriptionInCart = true;
                        if (mainSellingPlansIds && mainSellingPlansIds.indexOf(cart.items[i].selling_plan_allocation.selling_plan.id) >= 0){
                            mainProductInCart = true;
                        }
                    }
                    else {
                        var $optionalProduct = $('.optional-product-checkbox[value="'+ cart.items[i].id +'"]');
                        var isCustomPriced = $optionalProduct.attr('data-custom-price');
                        if ($optionalProduct.length && !isCustomPriced && $.isEmptyObject(cart.items[i].properties)){
                            cartQntArray.push(0);
                        }
                        else if ($optionalProduct.length && isCustomPriced && cart.items[i].properties['_custom_trial_price']) {
                            cartQntArray.push(0);
                        }
                        else {
                            cartQntArray.push(cart.items[i].quantity);
                        }
                    }
                    if (cart.items[i].properties && cart.items[i].properties['_bundle_id'] && cart.items[i].selling_plan_allocation){
                        anotherSubscriptionInCart = true;
                    }
                }

                if (mainSellingPlansIds && subscriptionInCart && !mainProductInCart){
                    anotherSubscriptionInCart = true;
                }
                if (anotherSubscriptionInCart) {
                    $('#subscription-in-cart-popup').fadeIn(300);
                    $('.complete-trial-order-btn', $container).removeClass('btn--loading');
                    return;
                }
                $.ajax({
                    type:     'POST',
                    url:      '/cart/update.js',
                    data:     {updates: cartQntArray},
                    dataType: 'json',
                    success:  function () {
                        callback();
                    },
                    error:    function (XMLHttpRequest, textStatus) {
                        $("html, body").animate({ scrollTop: 0 }, 1000);
                        $('.top-message-text').text('Something went wrong. Please try again!');
                        $('.top-message').slideDown(300);
                        $('.complete-trial-order-btn', $container).removeClass('btn--loading');
                        console.log(XMLHttpRequest, textStatus);
                    }
                });
            }
        });
    }

    function goToStep(nextStep, updateStateCallback) {
        $('.top-message').hide();
        $('.trial-step.trial-step-active', $container).hide().removeClass('trial-step-active');
        $('.trial-step-prev', $container).removeClass('trial-step-prev');
        $("html, body").animate({ scrollTop: 0 }, 0);
        if (nextStep < currentStep){
            $('.trial-step[data-step="' + nextStep + '"]', $container).addClass('trial-step-prev');
        }
        $('.trial-step[data-step="' + nextStep + '"]', $container).fadeIn(500).addClass('trial-step-active');
        $('.trial-page-loading', $container).removeClass('trial-page-loading');

        $('.trial-step-nav-current', $container).removeClass('trial-step-nav-current');
        $('.trial-step-nav[data-step="' + nextStep + '"]', $container).addClass('trial-step-nav-current');
        if (nextStep > 1) {
            $('.trial-step-nav', $container).addClass('trial-step-nav-available');
        }

        $('.trial-step-nav', $container).each(function (){
           if ($(this).attr('data-step') <= nextStep){
               $(this).addClass('trial-step-nav-completed');
           }
           else {
               $(this).removeClass('trial-step-nav-completed');
           }
        });
        $('.trial-steps-nav', $container).attr('data-current-step', nextStep);

        setTimeout(function(){
            $(".product-thumbnail__photos.slick-initialized").slick('setPosition');
        }, 10);

        currentStep = nextStep;

        if (updateStateCallback) {
            updateStateCallback();
        }
    };

    function changeExtrasBlockPosition(){
        if ($(window).width() > 767 && !$extrasBlock.hasClass('desktop-extras')) {
            $extrasBlock.addClass('desktop-extras').removeClass('mobile-extras').insertAfter($todaysOrderBlock);
        }
        else if ($(window).width() <= 767 && !$extrasBlock.hasClass('mobile-extras')){
            $extrasBlock.addClass('mobile-extras').removeClass('desktop-extras').insertAfter($yourSubscriptionBlock);
        }
    };

    function pushHistoryState(){
        var newUrl = new URL(location);
        newUrl.searchParams.set("step", currentStep);
        history.pushState({}, "", newUrl);
    }

    function replaceHistoryState(){
        if (!history.replaceState) {
            return;
        }
        var newUrl = new URL(location);
        newUrl.searchParams.set("step", currentStep);
        window.history.replaceState({}, "", newUrl);
    }
});

